import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setOpenModal, setLoading, setError, setIsSaved } from "../../../global-state/redux";
import { postRequest } from "../../../network/httpRequest";
import { urls } from "../../../constant";
import { TedButton } from "../../../core-ui";

const MemberDetailsModal = ({ data }) => {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    first_name: data?.first_name || "",
    last_name: data?.last_name || "",
    gender: data?.gender || "",
    umva_cardid: data?.umva_cardid || "",
    province: data?.province || "",
    commune: data?.commune || "",
    zone: data?.zone || "",
    colline: data?.colline || "",
    localite: data?.localite || "",
    group: data?.group || "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    dispatch(setLoading());
    const { err, msg, data: responseData, typeErr } = await postRequest(
      `${urls.deposit}/new-members/${data.id}`,
      formData
    );
    dispatch(setLoading());
    if (err) {
      return dispatch(setError({ err, msg, data: responseData, typeErr }));
    }
    dispatch(setIsSaved());
    setIsEditing(false);
    dispatch(setOpenModal({ actionName: "", data: null, actionTitle: "", number: 0 }));
  };

  const fieldStyle = {
    marginBottom: '15px',
    display: 'flex',
    flexDirection: 'column',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
    color: '#333',
  };

  const inputStyle = {
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
  };

  const valueStyle = {
    padding: '8px 12px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    fontSize: '14px',
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    marginTop: '20px',
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '15px',
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={gridStyle}>
        <div style={fieldStyle}>
          <label style={labelStyle}>Prénom</label>
          {isEditing ? (
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
              style={inputStyle}
            />
          ) : (
            <div style={valueStyle}>{data?.first_name}</div>
          )}
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Nom</label>
          {isEditing ? (
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
              style={inputStyle}
            />
          ) : (
            <div style={valueStyle}>{data?.last_name}</div>
          )}
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Sexe</label>
          {isEditing ? (
            <select
              name="gender"
              value={formData.gender}
              onChange={handleInputChange}
              style={inputStyle}
            >
              <option value="">Sélectionner</option>
              <option value="M">Masculin</option>
              <option value="F">Féminin</option>
            </select>
          ) : (
            <div style={valueStyle}>{data?.gender === 'M' ? 'Masculin' : 'Féminin'}</div>
          )}
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>UMVA Card ID</label>
          {isEditing ? (
            <input
              type="text"
              name="umva_cardid"
              value={formData.umva_cardid}
              onChange={handleInputChange}
              style={inputStyle}
            />
          ) : (
            <div style={valueStyle}>{data?.umva_cardid}</div>
          )}
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Province</label>
          {isEditing ? (
            <input
              type="text"
              name="province"
              value={formData.province}
              onChange={handleInputChange}
              style={inputStyle}
            />
          ) : (
            <div style={valueStyle}>{data?.province}</div>
          )}
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Commune</label>
          {isEditing ? (
            <input
              type="text"
              name="commune"
              value={formData.commune}
              onChange={handleInputChange}
              style={inputStyle}
            />
          ) : (
            <div style={valueStyle}>{data?.commune}</div>
          )}
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Zone</label>
          {isEditing ? (
            <input
              type="text"
              name="zone"
              value={formData.zone}
              onChange={handleInputChange}
              style={inputStyle}
            />
          ) : (
            <div style={valueStyle}>{data?.zone}</div>
          )}
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Colline</label>
          {isEditing ? (
            <input
              type="text"
              name="colline"
              value={formData.colline}
              onChange={handleInputChange}
              style={inputStyle}
            />
          ) : (
            <div style={valueStyle}>{data?.colline}</div>
          )}
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Localité</label>
          {isEditing ? (
            <input
              type="text"
              name="localite"
              value={formData.localite}
              onChange={handleInputChange}
              style={inputStyle}
            />
          ) : (
            <div style={valueStyle}>{data?.localite}</div>
          )}
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Groupe</label>
          {isEditing ? (
            <input
              type="text"
              name="group"
              value={formData.group}
              onChange={handleInputChange}
              style={inputStyle}
            />
          ) : (
            <div style={valueStyle}>{data?.group}</div>
          )}
        </div>
      </div>

      <div style={buttonContainerStyle}>
        {isEditing ? (
          <>
            <TedButton
              onClick={() => setIsEditing(false)}
              style={{
                backgroundColor: '#9E9E9E',
                color: 'white',
                padding: '8px 20px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Annuler
            </TedButton>
            <TedButton
              onClick={handleUpdate}
              style={{
                backgroundColor: '#4CAF50',
                color: 'white',
                padding: '8px 20px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Enregistrer
            </TedButton>
          </>
        ) : (
          !data?.is_synced && (
            <TedButton
              onClick={() => setIsEditing(true)}
              style={{
                backgroundColor: '#2196F3',
                color: 'white',
                padding: '8px 20px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Modifier
            </TedButton>
          )
        )}
      </div>
    </div>
  );
};

export default MemberDetailsModal;
